import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ title = "Loading..." }) => (
   
  <div className="text-center p-4">
    <Spinner animation="border" role="status" />
    <div className="mt-2 text-muted">{title}</div>
  </div>

);

export default LoadingSpinner;